<template>
  <div class="page-header-box">
    <div class="content_auto">
      <span
        class="page-header-content"
        :class="{ back: isShowBackIcon }"
        @click="onClick"
      >
        <span v-if="isShowBackIcon" class="icon">‹</span>
        <span>{{ title }}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: {
    url: {
      type: String,
      default: ''
    },
    title: String,
    isShowBackIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick() {
      if (!this.isShowBackIcon) return
      if (this.url) {
        this.$router.push({ path: this.url })
      } else {
        this.$router.back()
      }
    }
  }
}
</script>
<style scoped lang="less">
.page-header-box {
  background: #131625;
  min-width: fit-content;
  padding: 60px 0 30px;
  margin-bottom: 20px;
  .page-header-content {
    font-size: 20px;
    font-weight: 400;
    color: #fff !important;
    text-decoration: none;

    &.back {
      cursor: pointer;
    }

    .icon {
      margin-right: 10px;
    }
  }
}
</style>
